// extracted by css-extract-rspack-plugin
export default {"Box":"SubIssueAddedEvent-module__Box__NrP865K","Box_1":"SubIssueAddedEvent-module__Box_1__EQeQYeo"};